import React from "react";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import MarketNavbar from "../MarketNav/MarketNavbar";
import MarketplacePage from "../components/MarketplacePage";
import MarketProductSection from "../components/MarketProductSection";
import { MARKET_HOME_SECTIONS } from "../libs/marketSectionMeta";
import useRecommendedLimit from "../libs/fetchLimitRecommended";
import { ReactComponent as BagIcon } from "../../../Assets/bag-3-svgrepo-com 1.svg";
import { ReactComponent as CryingIcon } from "../../../Assets/crying-svgrepo-com 1.svg";
import "../Market.css";

const EmptyCart = () => {
  const {
    data: recommendedLimit,
    isLoading: recommendedLoading,
    isError: recommendedError,
  } = useRecommendedLimit();

  return (
    <Fragment>
      <MarketNavbar />
      <MarketplacePage className="empty-cart-page">
        <div className="empty-cart-container">
          <h3 className="empty-cart-title">Shopping bag</h3>
          <div className="empty-cart-card">
            <div className="empty-cart-icons">
              <CryingIcon style={{ fontSize: "40px" }} />
              <BagIcon style={{ fontSize: "48px" }} />
            </div>
            <div className="empty-bag">
              <h3>Your bag is empty</h3>
              <p>Browse categories and discover our best deals.</p>
              <Link to="/market">Start shopping</Link>
            </div>
          </div>
        </div>

        <MarketProductSection
          className="empty-cart-showcase"
          title={MARKET_HOME_SECTIONS.recommended.title}
          Icon={MARKET_HOME_SECTIONS.recommended.Icon}
          viewAllLink={MARKET_HOME_SECTIONS.recommended.link}
          isLoading={recommendedLoading}
          isError={recommendedError}
          products={recommendedLimit?.products || []}
          errorMessage={MARKET_HOME_SECTIONS.recommended.errorMessage}
          emptyMessage={MARKET_HOME_SECTIONS.recommended.emptyMessage}
          limit={5}
        />
      </MarketplacePage>
    </Fragment>
  );
};

export default EmptyCart;
